const topicTrendsConstants: TopicTrendsConstants = {
  STORE_WORD_CLOUD: 'STORE_WORD_CLOUD',
  RESET_TOPIC_TRENDS: 'RESET_TOPIC_TRENDS',
};
type TopicTrendsConstants = {
  STORE_WORD_CLOUD: string;
  RESET_TOPIC_TRENDS: string;
};
export default topicTrendsConstants;
